export default __webpack_public_path__ + "static/media/Aniket_Deb.f9d93757.png";